export default "__VITE_ASSET__BsoViFHH__"